/**
 * hub.coranchers.com API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface ShelfLifeBySiteCard { 
    title?: string | null;
    titleDisplay?: string | null;
    quantity?: string | null;
    totalAmount?: number;
    readonly totalAmountDisplay?: string | null;
    backgroundColor?: string | null;
    foregroundColor?: string | null;
}

